import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { chapters, type ServiceInfoChapter } from './chapters';

export type ServiceInfoState = {
    showServiceInfoDialog: boolean;
    serviceInfoChapter: ServiceInfoChapter;
};

export const defaultServiceInfoState: ServiceInfoState = {
    showServiceInfoDialog: false,
    serviceInfoChapter: chapters.welcome,
};

export const serviceInfoSlice = createSlice({
    name: 'serviceInfo',
    initialState: defaultServiceInfoState,
    reducers: {
        serviceInfoDialogClosed: state => {
            state.showServiceInfoDialog = false;
        },
        serviceInfoDialogOpenedAtChapter: (state, action: PayloadAction<ServiceInfoChapter>) => {
            state.showServiceInfoDialog = true;
            state.serviceInfoChapter = action.payload;
        },
    },
});

export const { serviceInfoDialogClosed, serviceInfoDialogOpenedAtChapter } = serviceInfoSlice.actions;

export default serviceInfoSlice.reducer;
